import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-file',
  templateUrl: './remove-file.component.html',
  styleUrls: ['./remove-file.component.scss']
})
export class RemoveFileComponent implements OnInit {

  notes:any
  role:any;

  constructor( @Inject(MAT_DIALOG_DATA) 
  public data: any, 
  private dialogRef: MatDialogRef<RemoveFileComponent>,
  private dialog : MatDialog, ) {
    this.role = localStorage.getItem("display-role");
   }

  ngOnInit(): void {
  }

  removeFile(){
    this.dialogRef.close({ data: 'confirmed', notes: this.notes }) 
  }

  onCancel(){
    this.dialogRef.close({ data: 'cancelled' })
  }

}
